import { ContentJsonNewsEntry } from "inbox-contentful/src/types";

export const isOnNewsTab = (article: ContentJsonNewsEntry) =>
    article.type === "newsEntry";

export const isOnEsportsTab = (article: ContentJsonNewsEntry) =>
    article.type === "esportNewsEntry";
